<div #gradient class="gradient"></div>
<div #avatar class="avatar"></div>
<div #speech class="speech">
    <div class="name" [style.color]="color">{{name}}</div>
    <div #content class="content"></div>
</div>
